// This contains all the constants that we might need in the project in a form of object.

const KEY_VALIDATION_POLICY = {
  AUTO_APPROVAL: "AutoApproval",
  ORG_ADMIN_APPROVAL: "OrgAdminApproval",
};

const SOURCE = {
  BAYUN_ADMIN: "BAYUN_ADMIN",
  BASE_KIT: "BASE_KIT",
};

export default {
  TAG_LENGTH: 128,
  SOURCE,
  KEY_TYPE: {
    PUBLIC: "PUBLIC",
    PRIVATE: "PRIVATE",
  },
  PROXY_URL: "",
  BASE_URL: "",
  DEV_PORTAL_BASE_URL: "https://sandbox.bayun.dev/dev-portal/",
  // BASE_URL: "https://bluejeans.digilockbox.com/lms/",
  // BASE_URL: "http://localhost:8080/lms/",
  // BASE_URL: "http://172.20.10.4:8080/lms/",
  MEMBER_APP_STATUS_LINKED: "Linked",
  MEMBER_APP_STATUS_UNLINKED: "Unlinked",
  MEMBER_APP_STATUS_NOT_EXISTS: "MemberAppNotExist",
  APP_KEY_PAIR_ROLE_ACCESS: "Access",
  APP_KEY_PAIR_ROLE_MEMBER_CREATION: "MemberCreation",
  APP_KEY_PAIR_ROLE_ORG_CREATION: "OrgCreation",
  APP_KEY_PAIR_ROLE_AUTHORISATION: "Authorization",
  DEFAULT_MEMBER_APPROVAL: "Auto-Approve",
  DEFAULT_APP_APPROVAL: "Auto-Approve",
  EXPLICIT_MEMBER_APPROVAL: "Explicit-Approve",
  EXPLICIT_APP_APPROVAL: "Explicit-Approve",
  DEFAULT_LOCK_BOX_EXPIRY: "10",
  DEFAULT_STATS_SYNC_TIME: "360",
  DEFAULT_MINIMUM_APPROVAL_COUNT: "1",
  DEFAULT_KEY_GENERATION_POLICY: "Envelope",
  KEY_GENERATION_POLICY: {
    ENVELOPE: "Envelope",
    CHAIN: "Chain",
    STATIC: "Static",
  },
  DEFAULT_ENCRYPTION_POLICY: "Org",
  MEMBER_ENCRYPTION_POLICY: "Member",
  DEFAULT_ENCRYPTION_MODE: "AES-256-GCM",
  DEFAULT_ENCRYPTION_STATUS: "true",
  LOGIN_FLOW_LOGIN: "loginFlow",
  LOGIN_FLOW_REGISTER: "registerFlow",
  MULTI_FACTOR_SINGLE_FA_WITH_PASSCODE: "SingleFAWithPasscode",
  MULTI_FACTOR_SINGLE_FA_WITH_SECURITY_QUESTIONS:
    "SingleFAWithSecurityQuestions",
  MULTI_FACTOR_SINGLE_FA_WITH_SECURITY_QUESTIONS_AND_PASSPHRASE:
    "SingleFAWithSecurityQuestionsAndPassphrase",
  MULTI_FACTOR_TWO_FACTOR_AUTHENTICATION_WITHOUT_PASSPHRASE:
    "TwoFactorAuthenticationWithoutPassphrase",
  MULTI_FACTOR_TWO_FACTOR_AUTHENTICATION_WITH_PASSPHRASE:
    "TwoFactorAuthenticationWithPassphrase",
  KGP_ORG: "ChainKGPObjectOrg",
  KGP_MEMBER: "ChainKGPObjectMember",
  KGP_GROUP: "ChainKGPObjectGroup",
  LMS_KEY_PREFIX: "lms",
  USER_STATUS_NOT_REGISTERED: "NotRegistered",
  MEMBER_PUBLIC_KEY_VERIFICATION_PURPOSE: {
    MEMBER_LOCK_BOX: "memberLockBox",
    ACTIVATE_MEMBER: "activateMember",
    TRANSACTION: "transaction",
    GROUP_OPERATION: "groupOperation",
    RECOVER_USER: "recoverUser",
  },
  MEMBER_STATUS: {
    REGISTERED: "Registered",
    APPROVED: "Approved",
    CANCELLED: "Cancelled",
    ADMIN: "Admin",
    SECURITY_ADMIN: "SecurityAdmin",
    AUTO_APPROVED: "AutoApproved",
  },
  USER_RECOVERY_STATUS: {
    RECOVERY_STARTED: "RecoveryStarted",
    SET_CREDENTIALS: "SetCredentials",
    NONE: "None",
  },
  KEY_VALIDATION_POLICY,
  CONTEXT_SEPARATOR: "$",
  SIGNATURE_SEPARATOR: "#",
  HASH_SEPARATOR: "$",
  // Context prefixes. Must stay identical to the LMS Constants of the same name — they are
  // rebuilt on both sides and compared byte for byte.
  ADMIN_SIGNING_PUBLIC_KEY: "adminSigningPublicKey",
  DEFAULT_KEY_VALIDATION_POLICY: KEY_VALIDATION_POLICY.AUTO_APPROVAL,
  TRANSACTION_STATUS: {
    IN_PROGRESS: "InProgress",
    APPROVED: "Approved",
    COMPLETED: "Completed",
    DECLINED: "Declined",
  },
  TRANSACTION_LABEL: {
    RECOVERY_FLOW: "recoveryFlow",
  },
  APPLICATION_TYPE: {
    ENTERPRISE: "Enterprise",
    CONSUMER: "Consumer",
  },
  ORG_TYPE: {
    ENTERPRISE: "Enterprise",
    CONSUMER: "Consumer",
  },
};
